import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import { mdiMessageTextOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { Drawer, Hidden, Slide } from '@material-ui/core';
import Dialog from 'components/DialogWrapper/DialogWrapper';
import ChatMenuContent from './components/ChatMenuContent';
import { useSelector } from 'react-redux';
import { getChatControlData } from 'components/ChatDialog/store/slices/chatSlice';
import SideBadge from 'components/SideBadge/SideBadge';
import { getProjectEmailData } from 'store/projectEmail/projectEmailSlice';
import { selectProjects } from 'store/projects/selectors/projectsSelectors';
import { selectUserActiveEmployerId } from 'store/user/selectors.js/user.selectors';

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" {...props} ref={ref} />
));
Transition.displayName = 'Transition';

const useStyles = makeStyles((theme) => ({
  iconButton: {
    height: 40,
    padding: 0,
    width: 40,
    [theme.breakpoints.up('sm')]: {
      margin: '0 4px',
    },
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
}));

const ChatButton = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const classes = useStyles();
  const { threads } = useSelector(getChatControlData);
  const { unreadMessages } = useSelector(getProjectEmailData);
  const allProjects = useSelector(selectProjects);
  const activeEmployerId = useSelector(selectUserActiveEmployerId);

  const threadsWithUnreadMessages = Object.values(threads).filter((thread) => {
    if (thread.unreadMessagesCount <= 0) return false;
    if (!activeEmployerId) return true;
    const project = allProjects[thread.projectId];
    return (
      project?.employer === activeEmployerId ||
      project?.id === activeEmployerId
    );
  }).length;

  const projectsWithUnreadEmailMessages = Object.entries(unreadMessages).filter(
    ([projectKey, count]) => {
      if (count <= 0) return false;
      if (!activeEmployerId) return true;
      return Object.values(allProjects).some(
        (project) =>
          project.projectKey === projectKey &&
          (project.employer === activeEmployerId ||
            project.id === activeEmployerId)
      );
    }
  ).length;

  const totalUnreadCount =
    threadsWithUnreadMessages + projectsWithUnreadEmailMessages;

  return (
    <>
      <Hidden xsDown>
        <IconButton
          className={classes.iconButton}
          onClick={() => setDrawerOpen(true)}
        >
          <SideBadge
            badgeContent={totalUnreadCount}
            color="secondary"
            invisible={totalUnreadCount === 0}
          >
            <Icon path={mdiMessageTextOutline} size={1} />
          </SideBadge>
        </IconButton>
        <Drawer
          anchor="right"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
        >
          <ChatMenuContent />
        </Drawer>
      </Hidden>
      <Hidden smUp>
        <IconButton
          className={classes.iconButton}
          onClick={() => setDrawerOpen(true)}
        >
          <SideBadge
            badgeContent={totalUnreadCount}
            color="secondary"
            invisible={totalUnreadCount === 0}
          >
            <Icon path={mdiMessageTextOutline} size={1} />
          </SideBadge>
        </IconButton>
        <Dialog
          fullScreen
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          TransitionComponent={Transition}
        >
          <ChatMenuContent />
        </Dialog>
      </Hidden>
    </>
  );
};

export default ChatButton;
